import { ChatModule } from './_ChatModule';

import { useRightSidebar } from '~/app/contexts/RightSidebarContext';

export const ChatSidebarContent = () => {
  const { close } = useRightSidebar();

  return (
    <div
      className={
        '@ChatSidebarContent flex h-full flex-col overflow-hidden bg-white/5'
      }
    >
      <ChatModule onClose={close} />
    </div>
  );
};
